import React from 'react';
import { Dialog, DialogContent, Avatar, Typography, Box, Divider, IconButton, Stack } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';

const UserProfileModal = ({ open, onClose, user }) => {
  // if (!user) return null;
  // console.log(user);
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogContent sx={{ p: 0 }}>
        <Box sx={{ textAlign: 'center', p: 2, bgcolor: '#e3f2fd' }}>
          <Avatar
            alt={user?.name || 'User'}
            src={user?.avatar || 'https://randomuser.me/api/portraits/men/75.jpg'}
            sx={{ width: 80, height: 80, mx: 'auto', mb: 1 }}
          />
          {/* <Typography variant="caption" color="green">
            ● available
          </Typography> */}
          <Typography variant="h6" sx={{ mt: 1 }}>
            {user?.name}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {user?.role.replace(/([A-Z])/g, ' $1').replace(/^./, (str) => str.toUpperCase())}
          </Typography>
        </Box>

        <Divider />

        <Box sx={{ px: 3, py: 2 }}>
          <Typography variant="h5" marginBottom={2} gutterBottom>
            Information
          </Typography>
          {/* {user?.address && ( */}
          <Stack direction="row" spacing={1} alignItems="center" mb={2}>
            <LocationOnIcon fontSize="small" />
            <Typography variant="body2">{user?.address || '32188 Sips Parkways, U.S'}</Typography>
          </Stack>
          {/* )} */}
          {/* {user?.phone && ( */}
          <Stack direction="row" spacing={1} alignItems="center" mb={2}>
            <PhoneIcon fontSize="small" />
            <Box
              component="a"
              href={`tel:${user?.phone || '+923014535021'}`}
              sx={{
                color: '#757575',
                textDecoration: 'none',
                fontSize: '14px',
                fontWeight: 400
              }}
            >
              {user?.phone || '+923014535021'}
            </Box>
          </Stack>
          {/* )} */}
          <Stack direction="row" spacing={1} alignItems="center" mb={2}>
            <EmailIcon fontSize="small" />
            <a
              href={`mailto:${user?.email}`}
              style={{
                color: '#757575',
                textDecoration: 'none',
                fontSize: '14px',
                fontWeight: 400
              }}
            >
              {user?.email}
            </a>
          </Stack>
          {user?.attachments && user?.attachments.length > 0 && (
            <>
              <Divider sx={{ my: 2 }} />
              <Typography variant="subtitle2" gutterBottom>
                Attachment
              </Typography>
              {user?.attachments.map((file, i) => (
                <Stack direction="row" spacing={2} alignItems="center" mb={1} key={i}>
                  <Box
                    sx={{
                      bgcolor: file.color || '#2196F3',
                      p: 1,
                      borderRadius: '8px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                  >
                    <InsertDriveFileIcon sx={{ color: '#fff' }} />
                  </Box>
                  <Box>
                    <Typography variant="body2">{file.name}</Typography>
                    <Typography variant="caption" color="text.secondary">
                      {file.date}
                    </Typography>
                  </Box>
                </Stack>
              ))}
            </>
          )}
        </Box>
      </DialogContent>

      <IconButton onClick={onClose} sx={{ position: 'absolute', right: 8, top: 8 }}>
        <CloseIcon />
      </IconButton>
    </Dialog>
  );
};

export default UserProfileModal;
